import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ThemeProvider } from './hooks/useTheme';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { installAutoErrorListeners } from './services/autoErrorReporter';
import './index.css';

installAutoErrorListeners();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </AppErrorBoundary>
  </StrictMode>
);
